module.exports = __webpack_public_path__ + "static/media/energetic_slightly-sad.137d433b.svg";